import { useEffect } from 'react';
import { storage, STORAGE_KEYS } from '../utils/storage';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export const parseUtmParams = (search) => {
  const params = new URLSearchParams(search);
  const utmParams = {};

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });

  return Object.keys(utmParams).length > 0 ? utmParams : null;
};

export const useUtmParams = () => {
  useEffect(() => {
    const utmParams = parseUtmParams(window.location.search);

    if (utmParams) {
      storage.setItem(STORAGE_KEYS.UTM_PARAMS, utmParams);
    }
  }, []);
};

export const getStoredUtmParams = () => {
  return storage.getItem(STORAGE_KEYS.UTM_PARAMS);
};

export default useUtmParams;
